module.exports = __webpack_public_path__ + "img/门诊案件调解-影像信息.1e471c62.jpg";